import { Stack, Alert, AlertTitle } from '@mui/material';

import { DeviceManageButtons } from '../playlist-manage/device-manage-buttons';
import { PaymentPricing } from '../payment-pricing/payment-pricing';

export const ActivationManage = ({ device, playlists }) => (
  <Stack
    gap={4}
    marginBottom={6}
    sx={{
      flexDirection: {
        sm: 'column',
        md: 'row',
      },
    }}
  >
    <DeviceManageButtons device={device} />
    <Stack flexGrow={1} gap={3} id="payment-disclaimer">
      <Alert severity="warning">
        <AlertTitle>Disclaimer</AlertTitle>
        We do not provide content; our service is a pure media player. To use our player, you must
        upload your own playlist. If you do not have a playlist, the player will not function, and
        therefore, you do not need to pay. Additionally, we do not allow activation for users who do
        not have their own playlists. Each device has a unique MAC address, so a payment is valid
        for only one device.
      </Alert>
      <PaymentPricing device={device} playlists={playlists} />
    </Stack>
  </Stack>
);
